import {Pipe, PipeTransform} from '@angular/core';
import {LocalStorageService} from '../_services';

@Pipe({
    name: 'projectLogo'
})

export class ProjectLogoPipe implements PipeTransform {
    constructor(private localStorage: LocalStorageService) {
    }

    transform(value: any, ...args: any[]): any {
        const selectedProject = this.localStorage.get('selected_project');
        const allProjectList = this.localStorage.get('project_list');
        const setProject = allProjectList.find(obj => obj.ref === value);
        if (setProject) {
            return args[0] === 'first' ? setProject.projectFirstWord : setProject.projectSecondWord;
        } else {
            return args[0] === 'first' ? selectedProject.projectFirstWord : selectedProject.projectSecondWord;
        }
    }

}
